<app-adminBotcreate *ngIf="orderStep == 'one'" orderStep="orderStep" [botDetails]="botDetails"
    (gotoStep)="goToStep($event)"></app-adminBotcreate>
<app-adminBotpreview *ngIf="orderStep == 'two'" orderStep="orderStep" [botDetails]="botDetails"
    (gotoStep)="goToStep($event)" [orderPlaceDet]="orderPlaceDet"></app-adminBotpreview>
<app-adminBotdetails *ngIf="orderStep == 'three'" orderStep="orderStep" [botDetails]="botDetails"></app-adminBotdetails>
<app-adminBotstop *ngIf="orderStep == 'four'" orderStep="orderStep" [botDetails]="botDetails"
    (gotoStep)="goToStep($event)"></app-adminBotstop>
